import React, {useState} from 'react';
import { useParams } from 'react-router-dom';

import { useSnackBar } from '../../../../hooks/snackBar';

import Abas from '../../../../components/Abas';

import FormBuyer from '../CadastroBuyer/FormBuyer';
import CdBuyer from '../CadastroCd/CdBuyer';
import FormCd from '../CadastroCd/FormCd';
import UsuarioBuyer from '../UsuarioBuyer';
import FormUsuario from '../UsuarioBuyer/UsuarioBuyerForm';
import RemuneracaoGreenerBuyer from '../RemuneracaoGreener';
import CategoriaProdutoBuyer from '../CategoriaProduto';

import './styles.scss';

const listAbas = [
    {nome: 'Dados Cadastrais', id: 1}, 
    {nome: 'Cadastro de Lojas / CDs', id: 2},
    // {nome: 'Categorias de Produto', id: 3},
    {nome: 'Usuários', id: 4}, 
    {nome: 'Remuneração Greeners', id: 5}
]

const BuyerAbas = () => {
    const { idEmpresa } = useParams();

    const { addSnackBar } = useSnackBar();

    const [abaActive, setAbaActive] = useState(1);
    const [formSelected, setFormSelected] = useState();
    const [idCd, setIdCd] = useState('');
    //const [idLoja, setIdLoja] = useState('');
    const [idUsuario, setIdUsuario] = useState('');

    const selectAba = (abaId) => {
        if (idEmpresa === null || idEmpresa == undefined) {
            setFormSelected(0);
            setAbaActive(1);
            addSnackBar({
                message: 'Finalize o cadastro inicial ou selecione um Buyer já cadastrado',
                info: 'warning',
                open: true
            });
        } else {
            setFormSelected(0);
            setAbaActive(abaId);
        }
    }

    const chamarFormCd = (value, idCd) => {
        setIdCd(idCd);
        setAbaActive(2);
        setFormSelected(value);
    }

    //const chamarFormLoja = (value, idLoja) => {
    //    setIdLoja(idLoja);
    //   setAbaActive(3);
    //    setFormSelected(value);
    //}

    const chamarFormUsuario = (value, idUsuario) => {
        setIdUsuario(idUsuario);
        setAbaActive(4);
        setFormSelected(value);
    }

    const carregar = (abaId) => {
        switch (abaId) {
            case 1:
                return (<FormBuyer />)
            case 2:
                return (<CdBuyer chamarForm={chamarFormCd} idEmpresa={idEmpresa}/>)
            case 3:
                return (<CategoriaProdutoBuyer cancelar={selectAba} idEmpresa={idEmpresa}/>)
            case 4:
                return (<UsuarioBuyer chamarForm={chamarFormUsuario} idEmpresa={idEmpresa} />)
            case 5:
                return (<RemuneracaoGreenerBuyer cancelar={selectAba} idEmpresa={idEmpresa}/>)
            case 6:
                return (<FormCd cancelar={selectAba} idCd={idCd} />)
            case 7:
                return (<FormUsuario cancelar={selectAba} idUsuario={idUsuario} />)
            default:
                break;
        }
    }

    return (
        <div>
            <div className="row">
                <span className="col-sm-3 col-md-3 col-lg-3 titulo">Buyers</span>
            </div>
            <div className="row negative-margin ml-1">
                <strong>Detalhe</strong>
            </div>
            <div className="row abas mt20">
                <div className="col-sm-12 col-md-12 col-lg-12">
                    <Abas 
                     abas={listAbas}
                     active={abaActive}
                     action={selectAba}
                    />
                </div>
            </div>
            <div>
                    {
                        carregar(formSelected > 0 ? formSelected : abaActive)
                    }
                </div>
        </div>
    )
}

export default BuyerAbas;